module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("MORE THAN WE CAN HANDLE")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Jocelyn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("My soul is weary with sorrow; strengthen me according to your word.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("PSALM 119:28")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("W")])]), _vm._v("hen Nichole was born with Down syndrome, the doctor told Ellen and Andy Stumbo that he was sorry. “Don’t say you are sorry,” Ellen chastised him. “Our baby is exactly who she is meant to be. God does not make mistakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You religious people handle things better,” the doctor replied."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn1",
      "id": "rfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As a pastor’s wife, Ellen told herself she ought to handle it just fine. But Ellen didn’t want her baby. She was afraid of an unknown future full of limitations, and she mourned the loss of the baby she had expected to welcome. “And I was afraid that my family in Mexico would believe the very thoughts I wrestled with that were prevalent in our culture. That I had done something wrong and was getting what I deserved. Or that Nichole would never be whole. Although I knew it was not true, those lies would suck at my heart, like leeches, and I painfully would pull them out.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn2",
      "id": "rfn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('i', [_vm._v("It would be easier if she died")]), _vm._v(", Ellen thought. "), _c('i', [_vm._v("The pain and sadness I have is engulfing me, Lord! I don’t know how I will ever be able to enjoy life again! I don’t want this child!")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Her wish for her baby to die terrified her. Sadness, worry, and anger plagued her so intensely that it was a relief to Andy when he left home for work. Finally one night, Ellen asked him, “The Bible says that God does not give us more than we can handle, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He paused. “[First Corinthians 10:13] is often taken out of context. That verse refers to temptation. God will not give us more "), _c('i', [_vm._v("temptation")]), _vm._v(" than we can handle.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Well, does God give us more than we can handle when it comes to . . . life?” Ellen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Yes, honey. If we could handle it, we would not need God. But when we are given more than we can handle, it is then, and only then, that we realize how much we need him.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('i', [_vm._v("This is more than I can handle, Lord")]), _vm._v(", Ellen prayed that night. "), _c('i', [_vm._v("I need you to step in.")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn3",
      "id": "rfn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("If you too feel overwhelmed right now, whether from a diagnosis, or a new test result, or the daily challenges that make up your new normal, then telling yourself you should be able to handle it will not help you. Jesus never said we should manage on our own. He said, “In this world you will have trouble. But take heart! I have overcome the world” (John 16:33). We don’t have to be strong enough to conquer it all—Jesus is! And it is his strength, not ours, that we are urged to rely upon throughout the Scriptures:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is my strength and my shield; my heart trusts in Him, and I am helped. (Ps. 28:7 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("God is our refuge and strength, an ever-present help in trouble. (Ps. 46:1)")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("I can do all this through him who gives me strength. (Phil. 4:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The next time you find yourself saying, “I can’t do this,” add two words on the end: “without you.” You were never meant to live your life "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("without God’s strength, his patience, his grace. Your life may be more than you can handle alone, but nothing is too difficult for God.")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Lord, this is more than I can handle on my own. Fill me with your strength. Grant me your love for my child. Thank you that you don’t make mistakes—help me truly believe it! In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What feels like more than you can handle right now?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is one area you’re trying to control but can’t?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Identify a time when God’s strength really carried you through.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83fcbcfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter02.vue
// module id = 87
// module chunks = 0